// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3TqRQ","label":"Completed_label__29vM1"};